// import required libraries
import $ from 'jquery';

// import components that run on every page

// Import Pages
import accessibility from './actions/accessibility';
import PageApply from './pages/PageApply';
import PageFrontPage from './pages/PageFrontPage';


// call functions
accessibility();
PageApply( $ );
PageFrontPage( $ );
